import { useDispatch, useSelector } from "react-redux";
import { ApiTypes } from "../../constants/ActionTypes";

import { AddMessage } from "./../../actions/Messages"

import { TextField, withStyles } from "@material-ui/core"
import "./chatfield.css"
const styles = {
  root: {
    background: "#222222"
  },
  input: {
    color: "#21D7EA"
  }
}

const Chatfield = ({ classes }) =>
{

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();



  const HandleSubmit = (evt, bIsDesktop = false) =>
  {

    evt.preventDefault();

    const sMsgContent = bIsDesktop ? evt.target.value : evt.target[0].value;

    if (sMsgContent.length < 1) return;
    const messageData = {
      headers: {
        TYPE: ApiTypes.POST
      },
      body: {
        user: {
          id: user.id,
          displayName: user.displayName
        },
        message: {
          content: sMsgContent,
          date: new Date()
        }
      }
    }


    dispatch(AddMessage(messageData));

    if (bIsDesktop)
    {
      evt.target.value = "";
      evt.target.style.height = "auto";
    }
    else
    {
      evt.target[0].value = "";
      evt.target[0].style.height = "auto";
    }

  }

  const HandleEnter = (evt) =>
  {
    if (evt.keyCode === 13 && !evt.shiftKey)
    {
      HandleSubmit(evt, true);
      evt.target.value = "";
    };
  }

  return (
    <div id="chatField">
      <form onSubmit={(evt) => HandleSubmit(evt)} >
        <TextField
          className={classes.root}
          inputProps={{
            className: classes.input
          }}
          autoFocus={true}
          multiline={true}
          fullWidth={true}
          onKeyDown={(evt) => HandleEnter(evt)}
          placeholder="sus"
        />
      </form>
    </div>
  )
}

export default withStyles(styles)(Chatfield);
